import { render, staticRenderFns } from "./ProvidersPublishersEdit.vue?vue&type=template&id=3421cea0"
import script from "./ProvidersPublishersEdit.vue?vue&type=script&lang=js"
export * from "./ProvidersPublishersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports